/**
 * TanStack Query hooks for `capi-event-quality-score-monitoring`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	capiEventQualityScoreMonitoringQueryKeys,
	type CreateCapiEventQualityScoreMonitoringBody,
	type CreateCapiEventQualityScoreMonitoringResponse,
	type ListCapiEventQualityScoreMonitoringResponse,
} from "./api";

export function useCapiEventQualityScoreMonitoringList(): UseQueryResult<
	ListCapiEventQualityScoreMonitoringResponse,
	Error
> {
	return useQuery({
		queryKey: capiEventQualityScoreMonitoringQueryKeys.list(),
		queryFn: list,
	});
}

export function useCapiEventQualityScoreMonitoringCreate(): UseMutationResult<
	CreateCapiEventQualityScoreMonitoringResponse,
	Error,
	CreateCapiEventQualityScoreMonitoringBody
> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: capiEventQualityScoreMonitoringQueryKeys.all });
		},
	});
}
